import { useEffect, useState } from "react";
import {
  Input,
  Modal as ReactModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  ButtonGroup,
  Button,
} from "reactstrap";
import { CARPENTER_GROUPS, CARPENTER_ROOMS } from "../constants";
import { Notification } from "../common/style";

const NewProjectModal = ({
  isOpen,
  toggle,
  onSuccess,
  isCanvasSupported,
}) => {
  const [notification, setNotification] = useState({ type: "", message: "" });
  const [isNotificationVisible, setIsNotificationVisible] = useState(true);
  const [inputValue, setInputValue] = useState("");

  const onDismissNotification = () => {
    setIsNotificationVisible(false);
  };

  const [isLoading, setIsLoading] = useState(false);

  const handleSaveClick = () => {
    onSuccess({
      name: inputValue,
      version,
    });

    toggle();
    setInputValue("");
  };

  const [version, setVersion] = useState(2);

  return (
    <>
      {notification.type && (
        <Notification
          color={notification.type === "error" ? "danger" : "success"}
          isOpen={isNotificationVisible}
          toggle={onDismissNotification}
        >
          {notification.message}
        </Notification>
      )}
      <ReactModal isOpen={isOpen} toggle={toggle} backdrop="static">
        {isLoading && (
          <div className="position-absolute d-flex justify-content-center align-items-center w-100 h-100 z-3">
            <Spinner />
          </div>
        )}
        <ModalHeader>Create Project</ModalHeader>
        <div className={`${isLoading ? "blurred" : ""}`}>
          <ModalBody>
            <Input
              type="text"
              className="mt-1"
              value={inputValue || ""}
              invalid={!inputValue}
              onChange={(ev) => setInputValue(ev.target.value)}
            />
            {isCanvasSupported && (
              <div className="mt-3">
                <p className="mb-1">Version</p>
                <ButtonGroup>
                  <Button
                    color="primary"
                    outline
                    onClick={() => setVersion(1)}
                    active={version == 1}
                  >
                    Canvas
                  </Button>
                  <Button
                    color="primary"
                    outline
                    onClick={() => setVersion(2)}
                    active={version == 2}
                  >
                    Table
                  </Button>
                </ButtonGroup>
              </div>
            )}
          </ModalBody>
          <ModalFooter className="pt-0 border-0">
            <Button
              className="mt-0"
              color="secondary"
              onClick={() => {
                toggle();
              }}
            >
              Cancel
            </Button>
            <Button
              size="m"
              className="mt-0"
              color="primary"
              onClick={handleSaveClick}
              disabled={!inputValue}
            >
              Create Project
            </Button>
          </ModalFooter>
        </div>
      </ReactModal>
    </>
  );
};

export default NewProjectModal;
